export default __webpack_public_path__ + "static/media/dealing-with-difficulties.5cc69ac2.svg";